import {BaseApiResponseModel} from "../../../infrastructure/models/base-api-response-model";
import type {EntityDescriptionSectionApiModel} from "./section/entity-description.section.api-model";

export class EntityDescriptionResponseApiModel extends BaseApiResponseModel {
  sections: Array<EntityDescriptionSectionApiModel>;

  constructor(model: EntityDescriptionResponseApiModel, request) {
    super(model, request);

    this.sections = model?.sections;
  }
}
